import {
  createContext, ReactNode, useCallback, useMemo, useState,
} from 'react';
import api from '../services/api';

export interface HTMLExportContextValue {
  postExportHTML: (html: Blob, pageId?: string) => void
  loading: boolean
}

export const HTMLExportContext = createContext<HTMLExportContextValue>({
  postExportHTML: (html: Blob) => html,
  loading: false,
});

const HTMLExportContextProvider = (props: { children: ReactNode }) => {
  const { children } = props;
  const [loading, setLoading] = useState(null);

  const postExportHTML = useCallback(async (html: Blob, pageId?: string) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('file', html, 'export.html');
    if (pageId != null) {
      formData.append('page_id', pageId);
    }

    const res = await api.post('/v1/htmlfiles/download-zip', formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });

    // Download the zip file
    const a = document.createElement('a');
    a.href = `${process.env.REACT_APP_API_URL}${res.data}`;
    a.download = 'html.zip';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setLoading(false);
    // サーバー側に保存したstatic htmlファイルを開きます
    // window.open(`${process.env.REACT_APP_API_URL}${res.data.htmlPath}`);
  }, []);

  const value: HTMLExportContextValue = useMemo(() => ({
    postExportHTML,
    loading,
  }), [postExportHTML, loading]);

  return <HTMLExportContext.Provider value={value}>{children}</HTMLExportContext.Provider>;
};

export default HTMLExportContextProvider;
